angular.module("vgresiduos").directive("destinationFollowupList", function () {
	return {
		scope: true,
		controller: "DestinationFollowupListCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/followup/followupList/destinationFollowupList_template.html",
		bindToController: {
			status: "@",
			newOptions: "=",
			numberOfDisposals: "=?",
			forcePaginationButton: "@?",
			noHeader: "@?"
		}
	};
});
